module.exports = __webpack_public_path__ + "img/图片3.dd79edb0.png";